import React, { useContext, useMemo } from 'react';

import ui from 'domains/ui';
import { useAppSelector } from 'utils/hooks';

import Button from 'components/shared/Button';
import Modal from 'components/shared/Modal';
import { ShufflerContext } from './Shuffler';
import StandardProductDetail from './StandardProductDetail';
import MobileProductDetail from './MobileProductDetail';

import type { ShufflerContextType } from './Shuffler';

type LoadProductButtonProps = {
  text: string;
  onClick: React.MouseEventHandler;
};

function LoadProductButton({ text, onClick }: LoadProductButtonProps) {
  return (
    <Button type="outline" onClick={onClick}>
      {text}
    </Button>
  );
}

type ShufflerProductDetailProps = {
  handleShowAdvancedFilters: (show: boolean) => void;
  onClick: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

function ShufflerProductDetail(props: ShufflerProductDetailProps) {
  const { product, setProduct, staticFilterData } = useContext(
    ShufflerContext
  ) as ShufflerContextType;
  const { onClick, handleShowAdvancedFilters } = props;
  const hasMobileNavigation = useAppSelector(ui.selectors.hasMobileNavigation);

  if (!product) return null;

  const buttonText = useMemo(
    () => (product.metaData.numtext > 0 ? 'Add Your Images & Text Now' : 'Add Your Images Now'),
    [product]
  );

  return (
    <Modal
      title={product.name}
      labelledBy="shuffler-product-detail"
      modalClass={['shuffler-modal']}
      primaryFooterGroup={
        hasMobileNavigation ? (
          <span />
        ) : (
          <LoadProductButton
            text={buttonText}
            onClick={() => {
              handleShowAdvancedFilters(false);
              setProduct(undefined);
            }}
          />
        )
      }
      onClose={() => setProduct(undefined)}
      lastFocusedElementId={`shuffler-product-${product.id}`}
    >
      <div className={`productDetail${staticFilterData?.detailContrast ? ' contrast' : ''}`}>
        {hasMobileNavigation && (
          <MobileProductDetail handleShowAdvancedFilters={handleShowAdvancedFilters} />
        )}
        {!hasMobileNavigation && <StandardProductDetail onClick={onClick} />}
      </div>
    </Modal>
  );
}

export default ShufflerProductDetail;
